import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import IndividualProduct from '../components/individualProduct';
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";

const BloodPressure2 = () => {
  const title = "Dr. Chek D - Accurate Blood Pressure Monitor for Home Use";
  const description =
    "Dr. Chek D Digital Blood Pressure Monitor ensures precise and reliable BP readings. Ideal for home use, featuring easy-to-read displays and a comfortable cuff design.";

    const productData = {
        name: "Dr. Chek WBP",
        image: "/images/Dr Chek WBP_270x270.webp",
        "description":"The Dr. Chek WBP Wrist Blood Pressure Meter offers convenient and accurate blood pressure monitoring at home. This portable wrist blood pressure monitor utilizes advanced technology for reliable readings. Ideal for individuals seeking easy home blood pressure measurement, the Dr. Chek WBP is designed for user-friendly operation. Track your blood pressure levels with precision and gain valuable insights into your cardiovascular health. This digital blood pressure meter provides quick results, empowering you to manage your well-being effectively. Explore the benefits of the Dr. Chek WBP for reliable blood pressure monitoring devices and proactive health management.",
        features: [
          "One touch automatic measurement.",
          "Intelligent pressurized; Double filter fuzzy algorithm to calculate suitable pressure, ensure best comport feeling and increase accuracy.",
          "Dual settings, allows two users to store up to 99 blood pressure readings with data and time for record comparison",
          "IHB (Irregular Heartbeat) detection function.",
          "Average value display of three times measurement.",
          "Power Saving Design: Auto power off the unit in 3minutes idling."
        ],
       "brochure": {
      "pages": [
        "/images/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure-page-1.jpg",
        "/images/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure-page-2.jpg",
    
      ],
      "url": "/Dr-Chek-WBP-Blood-Pressure-Monitor-brochure.pdf",
    }
  };
    
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="Blood pressure meter, Blood pressure monitor, Home blood pressure monitor, Digital blood pressure monitor, Wrist blood pressure monitor, Upper arm blood pressure monitor, BP Meter, Automatic blood pressure monitor, Smart BP monitor, Portable blood pressure checker, Best BP machine for home, Accurate blood pressure monitoring device, Rechargeable BP monitor, Wireless BP monitor, Buy blood pressure monitor online, FDA-approved blood pressure monitor, Medical-grade blood pressure meter, Digital sphygmomanometer, Affordable home BP monitor"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourwebsite.com" />
      </Helmet>
        <Header/>
        <ProductsBanner
        title="Dr. Chek WBP"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
         <IndividualProduct product={productData} />
         <Footer/>
        <WhatsAppFloatingButton/>
    </div>
  )
}

export default BloodPressure2